import script from "./MobileLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileLayout.vue?vue&type=script&lang=ts&setup=true"

import "./MobileLayout.vue?vue&type=style&index=0&id=5597bcc0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5597bcc0"]])

export default __exports__